
export const iconList = [
    // Programming Languages
    "devicon-javascript-plain", "devicon-javascript-plain colored",
    "devicon-typescript-plain", "devicon-typescript-plain colored",
    "devicon-python-plain", "devicon-python-plain colored",
    "devicon-java-plain", "devicon-java-plain colored",
    "devicon-c-plain", "devicon-c-plain colored",
    "devicon-cplusplus-plain", "devicon-cplusplus-plain colored",
    "devicon-csharp-plain", "devicon-csharp-plain colored",
    "devicon-php-plain", "devicon-php-plain colored",
    "devicon-ruby-plain", "devicon-ruby-plain colored",
    "devicon-go-plain-wordmark", "devicon-go-plain-wordmark colored",
    "devicon-rust-plain", "devicon-rust-plain colored",
    "devicon-swift-plain", "devicon-swift-plain colored",
    "devicon-kotlin-plain", "devicon-kotlin-plain colored",
    "devicon-dart-plain", "devicon-dart-plain colored",
    "devicon-scala-plain", "devicon-scala-plain colored",
    "devicon-perl-plain", "devicon-perl-plain colored",
    "devicon-lua-plain", "devicon-lua-plain colored",
    "devicon-r-plain", "devicon-r-plain colored",
    "devicon-haskell-plain", "devicon-haskell-plain colored",

    // Frontend Frameworks & Libraries
    "devicon-react-original", "devicon-react-original colored",
    "devicon-vuejs-plain", "devicon-vuejs-plain colored",
    "devicon-angularjs-plain", "devicon-angularjs-plain colored",
    "devicon-nextjs-original",
    "devicon-nuxtjs-plain", "devicon-nuxtjs-plain colored",
    "devicon-svelte-plain", "devicon-svelte-plain colored",
    "devicon-jquery-plain", "devicon-jquery-plain colored",
    "devicon-backbonejs-plain", "devicon-backbonejs-plain colored",
    "devicon-ember-original-wordmark", "devicon-ember-original-wordmark colored",
    "devicon-redux-original", "devicon-redux-original colored",
    "devicon-tailwindcss-plain", "devicon-tailwindcss-plain colored",
    "devicon-bootstrap-plain", "devicon-bootstrap-plain colored",
    "devicon-sass-original", "devicon-sass-original colored",
    "devicon-less-plain-wordmark", "devicon-less-plain-wordmark colored",
    "devicon-materialui-plain", "devicon-materialui-plain colored",
    "devicon-d3js-plain", "devicon-d3js-plain colored",

    // Backend Frameworks
    "devicon-nodejs-plain", "devicon-nodejs-plain colored",
    "devicon-express-original", "devicon-express-original colored",
    "devicon-nestjs-plain", "devicon-nestjs-plain colored",
    "devicon-spring-plain", "devicon-spring-plain colored",
    "devicon-django-plain", "devicon-django-plain colored",
    "devicon-flask-original", "devicon-flask-original colored",
    "devicon-fastapi-plain", "devicon-fastapi-plain colored",
    "devicon-laravel-plain", "devicon-laravel-plain colored",
    "devicon-symfony-original", "devicon-symfony-original colored",
    "devicon-rails-plain", "devicon-rails-plain colored",
    "devicon-dotnetcore-plain", "devicon-dotnetcore-plain colored",

    // Databases
    "devicon-postgresql-plain", "devicon-postgresql-plain colored",
    "devicon-mysql-plain", "devicon-mysql-plain colored",
    "devicon-mongodb-plain", "devicon-mongodb-plain colored",
    "devicon-sqlite-plain", "devicon-sqlite-plain colored",
    "devicon-redis-plain", "devicon-redis-plain colored",
    "devicon-oracle-original", "devicon-oracle-original colored",
    "devicon-microsoftsqlserver-plain", "devicon-microsoftsqlserver-plain colored",
    "devicon-firebase-plain", "devicon-firebase-plain colored",
    "devicon-cassandra-plain", "devicon-cassandra-plain colored",
    "devicon-mariadb-plain", "devicon-mariadb-plain colored",
    "devicon-graphql-plain", "devicon-graphql-plain colored",

    // DevOps & Tools
    "devicon-docker-plain", "devicon-docker-plain colored",
    "devicon-kubernetes-plain", "devicon-kubernetes-plain colored",
    "devicon-amazonwebservices-plain-wordmark", "devicon-amazonwebservices-plain-wordmark colored",
    "devicon-googlecloud-plain", "devicon-googlecloud-plain colored",
    "devicon-azure-plain", "devicon-azure-plain colored",
    "devicon-digitalocean-plain", "devicon-digitalocean-plain colored",
    "devicon-heroku-original", "devicon-heroku-original colored",
    "devicon-nginx-original", "devicon-nginx-original colored",
    "devicon-apache-plain", "devicon-apache-plain colored",
    "devicon-git-plain", "devicon-git-plain colored",
    "devicon-github-original", "devicon-github-original colored",
    "devicon-gitlab-plain", "devicon-gitlab-plain colored",
    "devicon-bitbucket-original", "devicon-bitbucket-original colored",
    "devicon-jenkins-line", "devicon-jenkins-line colored",
    "devicon-linux-plain",
    "devicon-ubuntu-plain", "devicon-ubuntu-plain colored",
    "devicon-debian-plain", "devicon-debian-plain colored",
    "devicon-bash-plain",

    // Tools & Editors
    "devicon-vscode-plain", "devicon-vscode-plain colored",
    "devicon-visualstudio-plain", "devicon-visualstudio-plain colored",
    "devicon-atom-original", "devicon-atom-original colored",
    "devicon-intellij-plain", "devicon-intellij-plain colored",
    "devicon-vim-plain", "devicon-vim-plain colored",
    "devicon-webpack-plain", "devicon-webpack-plain colored",
    "devicon-babel-plain", "devicon-babel-plain colored",
    "devicon-npm-original-wordmark", "devicon-npm-original-wordmark colored",
    "devicon-yarn-plain", "devicon-yarn-plain colored",
    "devicon-slack-plain", "devicon-slack-plain colored",
    "devicon-trello-plain", "devicon-trello-plain colored",
    "devicon-jira-plain", "devicon-jira-plain colored",
    "devicon-figma-plain", "devicon-figma-plain colored",
    "devicon-canva-original", "devicon-canva-original colored",
    "devicon-photoshop-plain", "devicon-photoshop-plain colored",
    "devicon-illustrator-plain", "devicon-illustrator-plain colored",
    "devicon-premierepro-plain", "devicon-premierepro-plain colored",
    "devicon-xd-plain", "devicon-xd-plain colored",
    "devicon-gimp-plain", "devicon-gimp-plain colored",
    "devicon-inkscape-plain", "devicon-inkscape-plain colored",
    "devicon-blend-original", "devicon-blender-original colored",
    "devicon-wordpress-plain", "devicon-wordpress-plain colored",
    "devicon-moodle-plain", "devicon-moodle-plain colored",
];
